const MeetingType = {
    QUICK: 'quick',
    SCHEDULE: 'schedule',
    TRAINING: 'training',
    CREATE_STEP: 'createStep',
    BEFORE_MIGRATION: 'beforeMigration',
    STATE_INITIALIZED: 'stateInitialized',
    SESSION_ONLY: 'sessionOnly',
    TEMPLATE: 'template'
};

module.exports = {
    MeetingType
};
